const getEnv = (key: string): string => import.meta.env[key] || ""

export const env = {
  onboardingFormApiUrl: getEnv("VITE_ONBOARDING_FORM_API_URL"),
  fboApiUrl: getEnv("VITE_API_URL"),
  fboAppUrl: getEnv("VITE_FBO_APP_URL"),
  useMockData: getEnv("VITE_USE_MOCK_DATA") === "true",
  previewDrawer: getEnv("VITE_PREVIEW_DRAWER") === "true",
  rollbarAccessToken: getEnv("VITE_ROLLBAR_ACCESS_TOKEN"),
  rollbarEnvironment: getEnv("VITE_ROLLBAR_ENVIRONMENT"),
  rollbarEnabled: getEnv("VITE_ROLLBAR_ENABLED") === "true",
  buildCommitSha: import.meta.env["VITE_BUILD_COMMIT_SHA"] || undefined,
}
